export enum UserDealDocumentDocumentTypeEnum {
  ContractOfSale = 1,
  DrivingLicenseSide1 = 2,
  DrivingLicenseSide2 = 3,
  AdditionalDocument = 4,
  ExpansionAddendum = 5,
}

export const UserDealDocumentDocumentTypeNames = {
  [UserDealDocumentDocumentTypeEnum.ContractOfSale]: 'Contract Of Sale',
  [UserDealDocumentDocumentTypeEnum.DrivingLicenseSide1]: `Driver's License Front`,
  [UserDealDocumentDocumentTypeEnum.DrivingLicenseSide2]: `Driver's License Back`,
  [UserDealDocumentDocumentTypeEnum.AdditionalDocument]: 'Additional Document',
  [UserDealDocumentDocumentTypeEnum.ExpansionAddendum]: 'Expansion Addendum',
};
